var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsAdd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h48v48H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 24.014C42 22.9 41.1 22 39.985 22l-13.963-.014V8.014c0-1.114-.9-2.014-2.015-2.014-1.115 0-2.015.9-2.015 2.014v13.972H8.015C6.9 21.986 6 22.886 6 24c0 1.114.9 2.014 2.015 2.014h13.977v13.972c0 1.114.9 2.014 2.015 2.014 1.115 0 2.015-.9 2.015-2.014V26.014H40c1.086 0 2.001-.914 2.001-2z",
    fill: "#111827",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsAdd);
export default __webpack_public_path__ + "static/media/icons-add.4bf776a04150e4e12ac203f71e1b7ade.svg";
export { ForwardRef as ReactComponent };